<div class="chart-container">
  <h4>Accumulated rainfall during last 24 hours: {{ totalRainfall | number:'1.2-2' }} inches</h4>

  <div class="gauge-selector">
    <label for="gauge-select">Select Rain Gauge:</label>
    @if (gaugesLoading) {
      <div class="selector-status">Loading gauges...</div>
    }
    @if (gaugesErrorMessage) {
      <div class="selector-status error-message">{{ gaugesErrorMessage }}</div>
    }

    @if (!gaugesLoading && !gaugesErrorMessage) {
      <select
        id="gauge-select"
        [(ngModel)]="selectedGaugeId"
        (change)="onGaugeChange()"
        [disabled]="gauges.length === 0">
        @if (gauges.length === 0) {
          <option value="" disabled>No gauges available</option>
        }
        @for (gauge of gauges; track gauge) {
          <option [value]="gauge.id">{{ gauge.name }}</option>
        }
      </select>
    }
  </div>

  @if (errorMessage) {
    <div class="error-message">
      <p>{{ errorMessage }}</p>
    </div>
  }

  <div class="chart-wrapper">
    <canvas baseChart
      [data]="barChartData"
      [options]="barChartOptions"
      [type]="barChartType">
    </canvas>

    @if (isLoading) {
      <div class="loading-overlay">
        <p>Loading rain data...</p>
        <div class="spinner"></div>
      </div>
    }

    @if (!isLoading && !errorMessage && barChartData.datasets[0].data.length === 0) {
      <div class="chart-placeholder">
        <p>No rain data available for the last 4 days.</p>
      </div>
    }
  </div>
</div>